import { ApiClient } from './ApiClient';
import User from '~/auth/User';
import Base64Helper from '~/helpers/Base64Helper';

export default class AuthApiClient extends ApiClient {
  private readonly BASE_URL: string = '/api/auth';
  public async validateToken(consoleToken: string): Promise<any> {
    return await this.post(`${this.BASE_URL}/login`, { consoleToken });
  }

  public async keepAlive() {
    if (this.isTokenExpiringSoon()) {
      await this.post(`${this.BASE_URL}/keep-alive`);
    }
  }

  protected isTokenExpiringSoon(thresholdInSeconds = 600) {
    const decodedToken = this.decodeJwt();
    const expirationTime = decodedToken.exp * 1000;
    const currentTime = Date.now();
    return expirationTime - currentTime < thresholdInSeconds * 1000;
  }

  private decodeJwt() {
    const token = User.getToken();
    return JSON.parse(Base64Helper.decode(token.split('.')[1]));
  }
}
